<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .field-table {
    margin: 0;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }

  .col-name {
    width: 25%;
  }

  .col-displayed {
    width: 20%;
    text-align: center;
  }

  .col-mandatory {
    width: 21%;
    text-align: center;
  }

  .col-update {
    width: 34%;
  }

  .tooltip-text {
    text-transform: none;
  }
</style>

<script>
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Table from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/Table.svelte";
  import TD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TD.svelte";
  import THEAD from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/THEAD.svelte";
  import TR from "@sourcewhale/shared/svelte-design-system/components/molecules/Table/TR.svelte";
  import { integrationStore } from "../../../../../../stores";

  export let displayedFieldInfo;
  export let mandatoryFieldInfo;
  export let protectedFieldInfo;

  $: providerTitle = $integrationStore.getProviderTitle();
</script>

<Table class="field-table">
  <colgroup>
    <col class="col-name" />
    <col class="col-displayed" />
    <col class="col-mandatory" />
    <col class="col-update" />
  </colgroup>
  <THEAD>
    <TR>
      <TD>NAME</TD>
      <TD>
        DISPLAYED FIELD
        <IconScale
          class="fa-circle-info info-icon"
          size="small"
          placement="top"
        >
          <span slot="tooltip" class="tooltip-text">{displayedFieldInfo}</span>
        </IconScale>
      </TD>
      <TD>
        MANDATORY FIELD
        <IconScale
          class="fa-circle-info info-icon"
          size="small"
          placement="top"
        >
          <span slot="tooltip" class="tooltip-text">{mandatoryFieldInfo}</span>
        </IconScale>
      </TD>
      <TD>
        Update field in {providerTitle}?
        <IconScale
          class="fa-circle-info info-icon"
          size="small"
          placement="top"
        >
          <span slot="tooltip" class="tooltip-text">{protectedFieldInfo}</span>
        </IconScale>
      </TD>
    </TR>
  </THEAD>
</Table>
